import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
// import "./BadgeComponent.css";

export interface myComponentProps {
  className?: string;
  dropdownClassName?: string;
  text?: string;
  onClick?: (param?: any) => void;
  children?: React.ReactNode;
  type?: string;
  style?: React.CSSProperties;
  padding?: string;
  stopPropagation?: boolean;
  loading?: boolean;
  loaderText?: string;
  isDropdown?: boolean;
  list?: { label: string; value?: any }[];
  onSelectItem?: (item: { label: string; value?: any }) => void;
}

interface ListProp {
  label: string;
  value?: any;
}

const RazorBadgeTwo: React.FC<myComponentProps> = ({
  text,
  className,
  children,
  onClick,
  type,
  style,
  padding,
  loading,
  loaderText,
  dropdownClassName,
  isDropdown,
  list,
  onSelectItem,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ListProp | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const getColor = () => {
    let val;
    if (type === "default") {
      val = "default";
    } else if (type === "yellow") {
      val = "pending";
    } else if (type === "green") {
      val = "success";
    } else if (type === "red") {
      val = "failed";
    } else if (type === "info") {
      val = "info";
    } else if (type === "purple") {
      val = "purple";
    }
    return val;
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleBadgeClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (loading) {
      return;
    }
    if (isDropdown && Array.isArray(list) && list.length > 0) {
      setIsOpen(!isOpen);
    }

    if (onClick) {
      onClick();
    }
  };

  const handleItemClick = (item: ListProp, e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(false);

    if (onSelectItem) {
      onSelectItem(item);
    }
    setSelectedItem(item);
  };

  const hasDropdownItems = isDropdown && Array.isArray(list) && list.length > 0;

  // Display selected item's label if available, otherwise use the text prop
  const displayText = selectedItem?.label || text || "";

  return (
    <div
      ref={dropdownRef}
      className={`badge-reusable-wrap-index`}
      style={{ position: "relative", display: "inline-block" }}
    >
      <div
        onClick={handleBadgeClick}
        className={`badge-wrap-index ${className?.toLowerCase()} ${
          type ? getColor() : ""
        } grey-bg-two`}
        style={{
          ...({
            "--padding-val": padding || "0.65rem 1.5rem",
          } as React.CSSProperties),
          ...style,
          cursor: hasDropdownItems || onClick ? "pointer" : "default",
          position: "relative",
        }}
      >
        {loading ? (
          <span
            className="loader-wrap"
            style={{
              display: "flex",
              cursor: "not-allowed",
              alignItems: "center",
              gap: loaderText ? "0.4rem" : "0",
              justifyContent: "center",
              // position: "absolute",
              // top: 0,
              // width: "100%",
              // height: "100%",
            }}
          >
            {loaderText && <span>{loaderText || "loading"}</span>}
            <span className="spin">
              <span className={`spintula spintula-arc `}></span>
            </span>
          </span>
        ) : (
          <>
            {children}
            <span>{displayText}</span>
            {hasDropdownItems && (
              <span className="badge-icon">
                {React.createElement(
                  FaChevronDown as React.ComponentType<any>,
                  {
                    style: {
                      cursor: "pointer",
                      width: "1rem",
                      height: "0.8rem",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    },
                  }
                )}
              </span>
            )}
          </>
        )}
      </div>

      {hasDropdownItems && isOpen && (
        <div className={`dropdown-wrap ${dropdownClassName} `}>
          {list.map((item: ListProp, idx) => (
            <span
              key={idx}
              onClick={(e) => handleItemClick(item, e)}
              style={{
                padding: "0.5rem 1rem",
                cursor: "pointer",
                borderBottom:
                  idx < list.length - 1 ? "1px solid #f0f0f0" : "none",
                transition: "background-color 0.2s ease",
              }}
            >
              {item.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default RazorBadgeTwo;
